import { useMutation } from '@tanstack/react-query';

export function useCopyToClipboardMutation() {
  return useMutation({
    mutationFn: async (content: string) => {
      return navigator.clipboard.writeText(content);
    }
  });
}
